<script setup lang="ts">
// 根组件: 仅承载路由出口 + 全局弹窗. 布局由 AppLayout / Login 各自承担.
import GlobalNotify from '@/components/common/GlobalNotify.vue'
import { useSessionGuard } from '@/composables/useSessionGuard'
import { checkAndDownloadUpdate } from '@/utils/ota'

useSessionGuard()
checkAndDownloadUpdate()
</script>

<template>
  <router-view />
  <GlobalNotify />
</template>
